import { Button } from "primereact/button";
import Utils from "util/Utils";
import { formatThumbprint } from "./opcUaUtils";

interface ThumbprintCellProps {
  thumbprint?: string;
}

/**
 * Table cell for a certificate thumbprint: abbreviated hex with the full value on hover,
 * plus click-to-copy. Kept on one line — nowrap on the row and flex-shrink-0 on the code
 * stop the copy button from squeezing the hex onto a second line in a narrow column.
 */
const ThumbprintCell = ({ thumbprint }: ThumbprintCellProps) => (
  <span className="flex align-items-center gap-1 white-space-nowrap">
    <code title={thumbprint} className="flex-shrink-0">
      {formatThumbprint(thumbprint)}
    </code>
    {thumbprint && (
      <Button
        className="p-button-text p-button-sm flex-shrink-0"
        icon="pi pi-copy"
        tooltip="Copy thumbprint"
        onClick={() => Utils.copyToClipboard(thumbprint, "Thumbprint")}
      />
    )}
  </span>
);

export default ThumbprintCell;
